/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { DebounceInput } from 'react-debounce-input';
import { useDispatch, useSelector } from 'react-redux';
import {
    addFilters,
    fetchFilterTransactions,
    setPage
} from '../features/filter/filterTransactions';

function FilterOptions() {
    const dispatch = useDispatch();
    const { page } = useSelector((state) => state.filter);

    const [input, setInput] = useState({
        search: '',
        type: ''
    });

    useEffect(() => {
        dispatch(fetchFilterTransactions({ type: input.type, search: input.search, page }));
        dispatch(addFilters({ type: input.type, search: input.search }));
    }, [dispatch, input.search, input.type, page]);

    // const handleReset=()=>{
    //     setInput({
    //         search:'',
    //         type:''
    //     })
    // }

    const handleChange = (e) => {
        const newInput = { ...input };
        newInput[e.target.name] = e.target.value;
        setInput(newInput);
        dispatch(setPage(1));
    };

    return (
        <div className="filter_options">
            {/* <div>
                <DebounceInput
                    debounceTimeout={400}
                    value={input.search}
                    className="search"
                    name="search"
                    type="search"
                    onChange={handleChange}
                    placeholder="Search"
                />
            </div> */}
            <div className="mb-6">
                <DebounceInput
                    debounceTimeout={400}
                    value={input.search}
                    className="search"
                    name="search"
                    type="search"
                    onChange={handleChange}
                    placeholder="Search"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
            </div>
            <div style={{ marginLeft: '10px' }} className="form-group radio">
                <div className="radio_group">
                    <input
                        type="radio"
                        value="income"
                        name="type"
                        onChange={handleChange}
                        required
                        className="accent-violet-500"
                    />
                    <label>Income</label>
                </div>
                <div className="radio_group">
                    <input
                        type="radio"
                        value="expense"
                        name="type"
                        onChange={handleChange}
                        required
                        className="accent-pink-500"
                    />
                    <label>Expense</label>
                </div>
                {/* <div>
                        <button className='reset' onClick={handleReset}>Reset</button>
                    </div> */}
            </div>
        </div>
    );
}

export default FilterOptions;
